module.exports = __webpack_public_path__ + "static/media/carpenter.5577c292.jpg";